import { PageRoutes } from '@/constants/PageRoutes'
import { APP_CONFIG } from '@/project-config'
import type { RouteRecordRaw } from 'vue-router'

export const getTopCreditRouter = (): RouteRecordRaw[] => {
  const routes: RouteRecordRaw[] = [
    // 404 not found重定向
  ]
  if (APP_CONFIG.isCompliant) {
    routes.push({
      path: PageRoutes.LegalCompliance,
      component: () => import('@/views/LegalComplianceView/LegalCompliance'),
      meta: {
        title: '法律与合规',
      },
    })
  }
  return routes
}
